import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  //   Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "2022", value: 115 },
  { name: "2023", value: 165 },
  { name: "2024", value: 205 },
  { name: "2025", value: 280 },
  { name: "2026", value: 325 },
  { name: "2027", value: 405 },
  { name: "2028", value: 490 },
  { name: "2029", value: 560 },
];

// const renderCustomTooltip = ({ payload }) => {
//   if (payload && payload.length > 0) {
//     const dataPoint = payload[0].payload;
//     return (
//       <div className="custom-tooltip">
//         <p>{dataPoint.name}</p>
//         <p
//           style={{ color: "rgb(53, 162, 235)" }}
//         >{`Number of global active device connections in billions: ${dataPoint.value}`}</p>
//       </div>
//     );
//   }
//   return null;
// };

const HmcMobileDataTrafficChart = () => {
  return (
    <div>
      <div className="ml-16 mb-7">
        <p className="text-left text-base font-bold mb-0">
          Mobile Data Traffic
        </p>
        <span>(Exabytes per month)</span>
        <sup className="text-[10px]">2</sup>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" />
          <YAxis />
          {/* <Tooltip content={renderCustomTooltip} /> */}
          {/* <Tooltip /> */}
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill="#C39F5C"
            animationBegin={500}
            animationDuration={1000}
            barSize={15}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HmcMobileDataTrafficChart;
